
import { mapActions, mapState, mapGetters } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  components: { ResponsiveDialog },
  props: {
    loading: false
  },
  data() {
    return {
      disIntegrationResons: [
        "Number of order is very low",
        "Account blocked",
        "Inconvenience to use Foaps",
        "Not worth for money",
        "Concerns over data parivacy",
        "Other"
      ],
      selectedReason: ""
    };
  },
  computed: {
    ...mapGetters("restaurant", ["getUnpairedChannelsList"])
  },
  methods: {
    isPairedChannel(channel) {}
  }
};
